import React from 'react';
import { Row, Col, Select, Input, DatePicker, Button, Divider, Card } from 'antd';
import { PlusOutlined, MinusCircleFilled } from '@ant-design/icons';

const { Option } = Select;

export default class AdvancedSearchFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: props.initialFilters || [],
      matchAll: props.initialMatchAll !== false,
    };
  }

  operatorsByType = {
    string: [
      { label: 'Contains', value: 'CO' },
      { label: 'Is', value: 'EQ' },
      { label: 'Starts with', value: 'BW' },
    ],
    date: [
      { label: 'Is', value: 'EQ' },
      { label: 'Is before', value: 'LT' },
      { label: 'Is after', value: 'GT' },
      { label: 'Is between', value: 'BE' },
      { label: 'Is not', value: 'NEQ' },
    ],
  };

  handleAddFilter = () => {
    this.setState(
      (prev) => ({
        filters: [...prev.filters, { field: null, operator: null, value: null }],
      }),
      this.propagateChange
    );
  };

  handleUpdateFilter = (index, key, value) => {
    const newFilters = [...this.state.filters];
    const currentFilter = newFilters[index];

    if (key === 'field' && currentFilter.field !== value) {
      const newFieldType = this.props.fields.find((f) => f.value === value)?.type;

      currentFilter.operator = null;
      currentFilter.value = newFieldType === 'date' ? null : '';

      if (newFieldType === 'date' && currentFilter.operator === 'BE') {
        currentFilter.value = [null, null];
      }
    }

    if (key === 'operator') {
      if (value === 'BE') {
        currentFilter.value = currentFilter.value ? currentFilter.value : [null, null];
      } else if (this.props.fields.find((f) => f.value === currentFilter.field)?.type === 'date') {
        currentFilter.value = null;
      }
    }

    currentFilter[key] = value;
    this.setState({ filters: newFilters }, this.propagateChange);
  };

  handleRemoveFilter = (index) => {
    this.setState(
      (prev) => ({
        filters: prev.filters.filter((_, i) => i !== index),
      }),
      this.propagateChange
    );
  };

  handleChangeMatchAll = (value) => {
    this.setState({ matchAll: value === 'ALL' }, this.propagateChange);
  };

  propagateChange = () => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(this.state.filters, this.state.matchAll);
    }
  };

  renderFilterRow = (filter, index) => {
    const { fields } = this.props;
    const field = fields?.find((f) => f.value === filter.field);
    const fieldType = field?.type;

    return (
      <Row gutter={8} style={{ marginBottom: 8 }} align="middle" key={index}>
        <Col>
          <Select
            placeholder="Field"
            value={filter.field}
            onChange={(val) => this.handleUpdateFilter(index, 'field', val)}
            style={{ width: 140 }}
          >
            {fields?.map((f) => (
              <Option key={f.value} value={f.value}>
                {f.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Select
            placeholder="Operator"
            value={filter.operator}
            onChange={(val) => this.handleUpdateFilter(index, 'operator', val)}
            style={{ width: 140 }}
          >
            {(this.operatorsByType[fieldType] || []).map((op) => (
              <Option key={op.value} value={op.value}>
                {op.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          {filter.operator === 'BE' ? (
            <>
              <DatePicker
                value={filter.value?.[0]}
                onChange={(val) => this.handleUpdateFilter(index, 'value', [val, filter.value?.[1] || null])}
              />
              <span style={{ margin: '0 8px' }}>AND</span>
              <DatePicker
                value={filter.value?.[1]}
                onChange={(val) => this.handleUpdateFilter(index, 'value', [filter.value?.[0] || null, val])}
              />
            </>
          ) : fieldType === 'date' ? (
            <DatePicker value={filter.value} onChange={(val) => this.handleUpdateFilter(index, 'value', val)} />
          ) : (
            <Input
              value={filter.value}
              onChange={(e) => this.handleUpdateFilter(index, 'value', e.target.value)}
              placeholder="Value"
            />
          )}
        </Col>
        <Col>
          <Button icon={<MinusCircleFilled />} type="link" onClick={() => this.handleRemoveFilter(index)} />
        </Col>
      </Row>
    );
  };

  render() {
    const { filters, matchAll } = this.state;

    return (
      <>
        <Row gutter={8} align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Button icon={<PlusOutlined />} onClick={this.handleAddFilter}>
              Add Filter
            </Button>
          </Col>
          <Col>
            <span>Search results match: {''}</span>
            <Select value={matchAll ? 'ALL' : 'ANY'} onChange={this.handleChangeMatchAll} style={{ width: 150 }}>
              <Option value="ALL">All</Option>
              <Option value="ANY">Any</Option>
            </Select>
          </Col>
        </Row>

        <Divider style={{ margin: '8px 4' }} />

        {filters.map((filter, index) => this.renderFilterRow(filter, index))}
      </>
    );
  }
}
